function foo(x: number) {
  x = x * 2;
  return x;
}
